// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"13fa8bb3","204":"0fadbb3a"}[chunkId] + ".chunk.js";
};